module.exports = __webpack_public_path__ + "static/media/045-andorra.155b7a38.svg";